<button class="wt-button"
        [type]="type"
        [class.wt-button--disabled]="disabled"
        [ngClass]="additionalClasses"
        [disabled]="disabled"
>
  <ng-content></ng-content>
</button>
